import { graphql } from "@repo/graphql-types/gql";

import { fetchQuery } from "@/hooks/use-graphql";
import type { RootRouteContext } from "@/routes/-root/-root-context";

export const EnsureRecipientHasAcceptedTermsOfUseQuery = graphql(/* GraphQL */ `
  query EnsureRecipientHasAcceptedTermsOfUseQuery($codUsuario: Int!, $codClinica: Int) {
    recipientTermsOfUseAgreed: expensum_recipient_terms_of_use_agreed(
      where: { termsOfUse: { active: { _eq: true } } }
    ) {
      id
    }
    ExpensumGetRecipient(arg1: { codClinica: $codClinica, codUsuario: $codUsuario }) {
      recipient {
        id
      }
    }
  }
`);

export const hasUserAcceptedOnlinePaymentTermsOfUse = async (
  context: RootRouteContext,
): Promise<boolean> => {
  const shouldDisplayUseTerms = context.flags["exibe-termos-de-uso-link-pagamento"];
  const isRecipientAccountRegistrationActive =
    context.flags["ativa-cadastro-de-conta-recebedora"];

  if (shouldDisplayUseTerms) {
    const { codUsuario, codClinica } = context.user;

    const queryResult = await fetchQuery(
      context,
      EnsureRecipientHasAcceptedTermsOfUseQuery,
      {
        codUsuario,
        codClinica,
      },
    );

    const hasRecipient = Boolean(queryResult.ExpensumGetRecipient?.recipient?.id);
    const hasAcceptedTerms = queryResult.recipientTermsOfUseAgreed.length > 0;

    if (isRecipientAccountRegistrationActive && !hasRecipient) {
      return false;
    }

    if (!hasAcceptedTerms && hasRecipient) {
      return false;
    }
  }
  return true;
};
